import * as React from "react";
import { getParse } from "../http/ruleApi";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { LOGIN_ROUTE } from "../utils/constants";
import { observer } from "mobx-react-lite";
import { Context } from "../index";

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  {
    field: "userId",
    headerName: "ID пользователя",
    width: 150,
    editable: false,
    sortable: true,
  },
  {
    field: "ruleId",
    headerName: "ID правила",
    width: 150,
    editable: false,
    sortable: true,
  },
  {
    field: "fileName",
    headerName: "Название файла",
    width: 150,
    editable: false,
    sortable: true,
  },
  {
    field: "contentProvider",
    headerName: "Контент-Провайдер",
    width: 150,
    editable: false,
    sortable: true,
  },
  {
    field: "period",
    headerName: "Период",
    width: 150,
    editable: false,
    sortable: true,
  },
  {
    field: "songName",
    headerName: "Название произведения",
    width: 150,
    editable: false,
    sortable: true,
  },
  {
    field: "singer",
    headerName: "Исполнитель",
    width: 150,
    editable: false,
    sortable: true,
  },
  {
    field: "platform",
    headerName: "Платформа",
    width: 150,
    editable: false,
    sortable: true,
  },
  {
    field: "downloads",
    headerName: "Кол-во скачиваний",
    width: 150,
    editable: false,
    sortable: true,
  },
  {
    field: "relatedContentCost",
    headerName: "Ст-ть ед, контента смежные",
    width: 150,
    editable: false,
    sortable: true,
  },
  {
    field: "authorContentCost",
    headerName: "Ст-ть ед, контента авторские",
    width: 150,
    editable: false,
    sortable: true,
  },
  {
    field: "relatedLicensePrize",
    headerName: "Вознаграждение Лицензиара смежные",
    width: 150,
    editable: false,
    sortable: true,
  },
  {
    field: "authorLicensePrize",
    headerName: "Вознаграждение Лицензиара авторские",
    width: 150,
    editable: false,
    sortable: true,
  },
];

const Main = observer(() => {
  const [parse, setParse] = React.useState([]);
  const navigate = useNavigate();
  const { user } = React.useContext(Context);

  React.useEffect(() => {
    const getData = async () => {
      try {
        const parsed = await getParse();
        setParse([...parsed]);
      } catch (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          user.setIsAuth(false);
          return navigate(LOGIN_ROUTE);
        }
      }
    };
    getData();
  }, []);

  return (
    <div>
      {parse && columns && (
        <Box sx={{ height: "100%", width: "100%" }}>
          <DataGrid
            rows={parse}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 100,
                },
              },
            }}
            pageSizeOptions={[10, 20, 50, 100]}
            checkboxSelection
            disableRowSelectionOnClick
          />
        </Box>
      )}
    </div>
  );
});

export default Main;
